module.exports = __webpack_public_path__ + "static/media/navIcon.9e0e5775.svg";